import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Plus, PenLine, Trash2, BookOpen, Star, Quote } from 'lucide-react';

export const BlogTab = ({ ctx }) => {
  const { blogPosts, setEditingBlog, setShowBlogModal, formatDate, handleDeleteBlog } = ctx;
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">Blog Posts</h2>
        <Button onClick={() => { setEditingBlog(null); setShowBlogModal(true); }} className="bg-[#0077B6] hover:bg-[#005A8C]">
          <Plus className="h-4 w-4 mr-2" />Add New Post
        </Button>
      </div>
      <div className="space-y-4">
        {blogPosts.map((post) => (
          <Card key={post.id} className="shadow-sm">
            <CardContent className="p-4">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-semibold text-gray-800">{post.title}</h3>
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${post.published ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                      {post.published ? 'Published' : 'Draft'}
                    </span>
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs font-medium">{post.category}</span>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-2">{post.excerpt}</p>
                  <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
                    <span>By {post.author}</span>
                    <span>{formatDate(post.created_at)}</span>
                  </div>
                </div>
                <div className="flex gap-2 ml-4">
                  <Button size="sm" variant="outline" onClick={() => { setEditingBlog(post); setShowBlogModal(true); }}>
                    <PenLine className="h-4 w-4" />
                  </Button>
                  <Button size="sm" variant="outline" className="text-red-600 hover:bg-red-50" onClick={() => handleDeleteBlog(post.id)}>
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {blogPosts.length === 0 && (
          <div className="text-center py-12">
            <BookOpen className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500">No blog posts yet</p>
            <Button onClick={() => setShowBlogModal(true)} className="mt-4 bg-[#0077B6]">Create Your First Post</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export const TestimonialsTab = ({ ctx }) => {
  const { testimonials, setEditingTestimonial, setShowTestimonialModal, handleDeleteTestimonial } = ctx;
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">Client Testimonials</h2>
        <Button onClick={() => { setEditingTestimonial(null); setShowTestimonialModal(true); }} className="bg-[#0077B6] hover:bg-[#005A8C]">
          <Plus className="h-4 w-4 mr-2" />Add Testimonial
        </Button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {testimonials.map((testimonial) => (
          <Card key={testimonial.id} className="shadow-sm">
            <CardContent className="p-4">
              <div className="flex justify-between items-start mb-3">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className={`h-4 w-4 ${i < testimonial.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-gray-300'}`} />
                  ))}
                </div>
                <span className={`px-2 py-0.5 rounded text-xs font-medium ${testimonial.published ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                  {testimonial.published ? 'Published' : 'Draft'}
                </span>
              </div>
              <p className="text-gray-700 italic mb-3">"{testimonial.testimonial_text}"</p>
              <div className="flex justify-between items-end">
                <div>
                  <p className="font-semibold text-gray-800">{testimonial.client_name}</p>
                  <p className="text-sm text-gray-500">{testimonial.client_location} • {testimonial.service_type}</p>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" onClick={() => { setEditingTestimonial(testimonial); setShowTestimonialModal(true); }}>
                    <PenLine className="h-4 w-4" />
                  </Button>
                  <Button size="sm" variant="outline" className="text-red-600 hover:bg-red-50" onClick={() => handleDeleteTestimonial(testimonial.id)}>
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {testimonials.length === 0 && (
          <div className="col-span-2 text-center py-12">
            <Quote className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500">No testimonials yet</p>
            <Button onClick={() => setShowTestimonialModal(true)} className="mt-4 bg-[#0077B6]">Add Your First Testimonial</Button>
          </div>
        )}
      </div>
    </div>
  );
};
